import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var HipersensibleService = /** @class */ (function () {
    function HipersensibleService(http) {
        this.http = http;
        this.cargadoHipersensible = true;
        this.hipersensible = [];
        this.hipersensibleRFL = [];
        this.hipersensibleRFC = [];
        this.hipersensibleRFP = [];
        this.hipersensibleRCL = [];
        this.hipersensibleRCC = [];
        this.hipersensibleRCP = [];
        this.cargarHipersensible();
    }
    HipersensibleService.prototype.cargarHipersensible = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.hipersensible = resp;
                _this.hipersensibleRFL = _this.hipersensible[7].rutinafacial.limpieza;
                _this.hipersensibleRFC = _this.hipersensible[7].rutinafacial.cuidado;
                _this.hipersensibleRFP = _this.hipersensible[7].rutinafacial.proteccion;
                _this.hipersensibleRCL = _this.hipersensible[7].rutinacorporal.limpieza;
                _this.hipersensibleRCC = _this.hipersensible[7].rutinacorporal.cuidado;
                _this.hipersensibleRCP = _this.hipersensible[7].rutinacorporal.proteccion;
                setTimeout(function () {
                    _this.cargadoHipersensible = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    HipersensibleService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    HipersensibleService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], HipersensibleService);
    return HipersensibleService;
}());
export { HipersensibleService };
//# sourceMappingURL=hipersensible.service.js.map